<div class="logo-wrapper">
  <div [ngStyle]="{'font-size': fz+'px'}" class="logo">
    <span i18n>КРЕДИТ</span>
    <span class="text-info" i18n>ПРО</span></div>
</div>
